import { useEffect, useState } from 'react';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';

interface UserProfile {
  id: string;
  name: string;
  email: string;
  role: string;
}

export const ProfilePage = () => {
  const [user, setUser] = useState<UserProfile | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const apiBase = import.meta.env.VITE_API_BASE || '';
        const token = localStorage.getItem('accessToken');
        const res = await fetch(`${apiBase}/api/auth/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.ok) {
          const data = await res.json();
          setUser(data.data);
        }
      } catch (error) {
        console.error('Failed to load profile', error);
      } finally {
        setLoading(false);
      }
    };
    fetchProfile();
  }, []);

  if (loading) return <div className="p-8">Loading profile...</div>;
  if (!user) return <div className="p-8">Failed to load profile.</div>;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Profile Settings</h1>
        <p className="text-gray-500">Manage your global account information.</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Basic Information</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="grid gap-2">
            <Label>Full Name</Label>
            <Input defaultValue={user.name} />
          </div>
          <div className="grid gap-2">
            <Label>Email Address</Label>
            <Input defaultValue={user.email} disabled className="bg-gray-100" />
            <p className="text-xs text-gray-500">Email cannot be changed directly. Contact support.</p>
          </div>
          <div className="grid gap-2">
            <Label>Applicant ID (System)</Label>
            <Input defaultValue={user.id} disabled className="bg-gray-100 font-mono text-sm" />
          </div>
        </CardContent>
      </Card>

      <div className="flex justify-end gap-2">
        <Button variant="outline">Cancel</Button>
        <Button onClick={() => alert('Profile update simulation: Saved.')}>Save Changes</Button>
      </div>
    </div>
  );
};
